<div class="signin-page-wrap height-100">
    <div class="register-confirmation-page-wrap height-100">
        <div class="session-form-hold">
            <div class="text-center pt-8 pb-16">
                <h2 class="mb-1">
                    <strong>Student's Details</strong>
                </h2>
                <p class="body-text">
                    Please enter your details below to complete your
                    registration.
                </p>
            </div>
            <form [formGroup]="studentUpdateForm" (ngSubmit)="onSubmit()">
                <div
                    class="mb-1 qtac-error-container"
                    data-test="error-message-register-main"
                    *ngIf="showRegisterProfileInvalid"
                >
                    {{ studentUpdateErrorMessage }}
                </div>
                <div class="mb-1">
                    <div>First Name *</div>
                    <input
                        class="qtac-input"
                        data-test="register-input-firstName"
                        name="firstName"
                        formControlName="firstName"
                        value=""
                    />
                    <div class="help-text">
                        First Name must match your <strong>Given Names</strong> field in the My details section of the QCAA Student Portal
                    </div>
                    <ng-container
                        *ngFor="let error of error_messages.firstName"
                    >
                        <small
                            data-test="error-first-name"
                            *ngIf="
                                formControls.firstName.hasError(error.type) &&
                                formControls.firstName.touched
                            "
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>
                <div class="mb-1">
                    <div>Last Name *</div>
                    <input
                        class="qtac-input"
                        data-test="register-input-lastName"
                        name="lastName"
                        formControlName="lastName"
                        value=""
                    />
                    <div class="help-text">
                        Last Name must match your <strong>Family Name</strong> field in the My details section of the QCAA Student Portal
                    </div>
                    <ng-container *ngFor="let error of error_messages.lastName">
                        <small
                            data-test="error-last-name"
                            *ngIf="
                                formControls.lastName.hasError(error.type) &&
                                formControls.lastName.touched
                            "
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>Date of Birth *</div>
                    <div fxLayout="row">
                        <input
                            matInput
                            class="qtac-input"
                            data-test="register-input-dob"
                            name="dob"
                            formControlName="dob"
                            value=""
                            [matDatepicker]="dob"
                            [max]="maxDate"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="dob"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #dob></mat-datepicker>
                    </div>
                    <ng-container *ngFor="let error of error_messages.dob">
                        <small
                            data-test="error-dob"
                            *ngIf="
                                formControls.dob.hasError(error.type) &&
                                formControls.dob.touched
                            "
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>Mobile Phone</div>
                    <div fxLayout="row">
                        <span class="mobile-prefix">+61</span>
                        <input
                            type="phone"
                            class="qtac-input"
                            data-test="register-input-phone"
                            name="phone"
                            formControlName="phone"
                            (change)="updateNumber()"
                        />
                    </div>
                    <ng-container *ngFor="let error of error_messages.phone">
                        <small
                            data-test="error-phone"
                            *ngIf="
                                formControls.phone.hasError(error.type) &&
                                formControls.phone.touched
                            "
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>LUI *</div>
                    <input
                        type="text"
                        minlength="10"
                        maxlength="10"
                        pattern="\d*"
                        class="qtac-input"
                        data-test="register-input-lui"
                        name="lui"
                        formControlName="lui"
                        value=""
                    />
                    <ng-container *ngFor="let error of error_messages.lui">
                        <small
                            data-test="error-lui"
                            *ngIf="
                                formControls.lui.hasError(error.type) &&
                                formControls.lui.touched
                            "
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <mat-divider></mat-divider>
                <div class="pt-05 pb-1">
                    <div class="pb-1">Customer Declaration *</div>
                    <mat-checkbox
                        ngDefaultControl
                        name="agreed"
                        data-test="register-checkbox-tos"
                        formControlName="agreed"
                        class="pb-1"
                        >I acknowledge that I have read, understood, and agree
                        to be bound by the policies, terms and conditions set
                        forth in the following as displayed on the
                        <a
                            class="text-link"
                            target="_blank"
                            href="https://www.qtac.edu.au/about-us/policies"
                            >QTAC website</a
                        >:
                    </mat-checkbox>
                    <ul>
                        <li>QTAC’s Documentation Guidelines</li>
                        <li>QTAC’s Applicant Rights and Responsibilities</li>
                        <li>QTAC’s Privacy Policy</li>
                        <li>QTAC’s Refund Policy</li>
                        <li>QTAC Mandatory consents and acknowledgements</li>
                    </ul>
                    <small
                        *ngIf="
                            studentUpdateForm.controls['agreed'].hasError(
                                'agreed'
                            ) && studentUpdateForm.controls['agreed'].touched
                        "
                        class="form-error-msg"
                        data-test="error-message-register"
                    >
                        You must agree to the Customer Declaration.
                    </small>
                </div>
                <mat-divider></mat-divider>

                <div class="pb-1 pt-05">
                    <div>Optional consent</div>
                    <div class="pb-1 small-text">
                        Please tick the box/es if you do not consent
                    </div>
                    <mat-checkbox
                        ngDefaultControl
                        name="optIn"
                        data-test="register-checkbox-opt-in"
                        formControlName="optIn"
                        class="pb-1"
                        >I do not consent to my ATAR or ATAR eligibility as
                        determined by QTAC being shared with the school I
                        attended in year 12.
                    </mat-checkbox>
                    <div class="pb-1"></div>
                    <mat-checkbox
                        ngDefaultControl
                        name="sendEmail"
                        data-test="register-checkbox-send-email"
                        formControlName="sendEmail"
                        class="pb-1"
                        >I do not want to receive an email notifying me that
                        my ATAR result has been released.
                </mat-checkbox>
                </div>
                <mat-divider></mat-divider>
                <div class="text-center">
                    <button
                        data-test="student-update-submit"
                        mat-raised-button
                        class="register-confirmation-button mb-1"
                        [disabled]="studentUpdateForm.invalid"
                    >
                        COMPLETE REGISTRATION
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
